import { render, staticRenderFns } from "./WsStaticLocale.vue?vue&type=template&id=64edae45&"
import script from "./WsStaticLocale.vue?vue&type=script&lang=js&"
export * from "./WsStaticLocale.vue?vue&type=script&lang=js&"
import style0 from "./WsStaticLocale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
